import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableCellInfo,
    FormLine,
    FormField,
    FormInput,
    FormLabel,
    Title,
} from 'yurstrap';

import {
    getCookiesGroupsConfigurationSelector,
    getFirstPartyCookieConfigurationSelector,
    isCookieAcceptedSelector,
    setCookie,
} from '../reduxModules/ConsentManagementPlatform';

import FirstPartyCookie from '../constants/FirstPartyCookie';
import CMPCookiesGroup from './CMPCookiesGroup';

const propTypes = {
    AppActions: PropTypes.shape({
        setCookie: PropTypes.func.isRequired,
    }).isRequired,
    config: PropTypes.array.isRequired,
    firstPartyCookie: PropTypes.object.isRequired,
    isFirstPartyCookieAccepted: PropTypes.bool.isRequired,
};

export class CMPCookiesTable extends Component {

    constructor(props) {
        super(props);
        this.toggleFirstPartyPersonalization = this.toggleFirstPartyPersonalization.bind(this);
    }

    toggleFirstPartyPersonalization() {
        const { AppActions, isFirstPartyCookieAccepted, firstPartyCookie } = this.props;
        const cookieId = firstPartyCookie.id;
        if (isFirstPartyCookieAccepted) {
            // If the cookie is already accepted, set isAccepted to false
            AppActions.setCookie(cookieId, false);
        } else {
            // If the cookie isn't already accepted, set isAccepted to true
            AppActions.setCookie(cookieId, true);
        }
    }

    renderFunctionalCookiesCell() {
        return (
            <Table
                className="mb-3"
                border
            >
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Cookies de fonctionnement
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <TableCellInfo>
                            Ces cookies sont nécessaires à l’usage de base de Yurplan
                            et ne peuvent être désactivés au risque d’influencer négativement
                            votre parcours sur notre site. Ces cookies sont utiles pour savoir
                            si votre compte existe, déterminer si vous êtes déjà connecté(e),
                            mais aussi pour vous permettre de naviguer pleinement sur le site,
                            de changer de page sans avoir à vous reconnecter, de procéder au
                            paiement d’une commande, ou encore d’utiliser l'une des nombreuses
                            fonctionnalités du site.
                            </TableCellInfo>
                        </TableCell>
                        <TableCell>
                            <FormLine
                                disabled
                                className="mb-0"
                            >
                                <FormField type="toggle">
                                    <FormInput
                                        className="mr-4"
                                        id="cookies-standard"
                                        type="checkbox"
                                        disabled
                                        checked
                                    />
                                    <FormLabel htmlFor="cookies-standard" />
                                </FormField>
                            </FormLine>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    renderPersonalizationCookiesCell() {
        const {
            firstPartyCookie,
            isFirstPartyCookieAccepted,
        } = this.props;
        return (
            <Table
                className="mb-3"
                border
            >
                <TableHead>
                    <TableRow>
                        <TableCell>
                            {firstPartyCookie.title}
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            <TableCellInfo>
                                {firstPartyCookie.description}
                            </TableCellInfo>
                        </TableCell>
                        <TableCell>
                            <FormLine className="mb-0">
                                <FormField type="toggle">
                                    <FormInput
                                        className="mr-4"
                                        id={firstPartyCookie.id}
                                        type="checkbox"
                                        checked={isFirstPartyCookieAccepted}
                                        onChange={this.toggleFirstPartyPersonalization}
                                    />
                                    <FormLabel htmlFor={firstPartyCookie.id} />
                                </FormField>
                            </FormLine>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    renderThirdPartyCookies() {
        const { config } = this.props;
        return _.map(config, (cookiesGroup) => (
            <CMPCookiesGroup
                key={cookiesGroup.id}
                cookieGroupId={cookiesGroup.id}
            />
        ));
    }

    render() {
        return (
            <>
                <Title
                    componentClass="h4"
                    className="mt-4"
                >
                    Cookies maison
                </Title>
                {this.renderFunctionalCookiesCell()}
                {this.renderPersonalizationCookiesCell()}
                <Title
                    componentClass="h4"
                    className="mt-4"
                >
                    Cookies tiers
                </Title>
                {this.renderThirdPartyCookies()}
            </>
        );
    }

}

CMPCookiesTable.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        config: getCookiesGroupsConfigurationSelector(state),
        firstPartyCookie: getFirstPartyCookieConfigurationSelector(state),
        isFirstPartyCookieAccepted: isCookieAcceptedSelector(state, FirstPartyCookie.id),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCookie,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CMPCookiesTable);
